<template>
  <PTooltip
    v-if="absence"
    :label="`${name} est ${genderize('absent', civility)}${absence.until ? ` jusqu’au ${dayjs(absence.until).format('DD/MM/YYYY')}` : ''}`"
    :delay="500"
  >
    <OhVueIcon :name="absenceIcon" />
  </PTooltip>
</template>

<script setup lang="ts">
import { genderize } from "@/app/utils/gender";
import { PTooltip, useIcons } from "@pasta/box-v2";
import dayjs from "dayjs";
import { OhVueIcon } from "oh-vue-icons";
import { FaCalendarTimes } from "oh-vue-icons/icons";

type Props = { name: string; absence: { until?: Date }; civility?: number };
defineProps<Props>();

const [absenceIcon] = useIcons(FaCalendarTimes);
</script>
